import { render, staticRenderFns } from "./ModalTool.vue?vue&type=template&id=5fefbe7e&scoped=true&"
import script from "./ModalTool.vue?vue&type=script&lang=ts&"
export * from "./ModalTool.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTool.vue?vue&type=style&index=0&id=5fefbe7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fefbe7e",
  null
  
)

export default component.exports